import styled from 'styled-components';

const PaymentSelection = styled.div`
  margin-top: 1rem;

  ${Styles.mobileFullscreen`
    margin-bottom: calc(50px + 1rem);
  `}
`;

export default PaymentSelection;
